import React from 'react'
import useModalData from '../../../../elements/Hooks/useModalData'
import { PaymentTermsApi } from '../../../../api/People/PaymentTerms'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { isEmpty } from 'lodash'
import PaymentTerms from '../../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTerms'
import { message } from 'antd'

PaymentTermsCont.propTypes = {}

function PaymentTermsCont(props) {
  const { owner, isUpdatable } = props
  const { fetching, fetch, list } = useFetchList(
    () => PaymentTermsApi.list(owner._id),
    [owner._id],
    isEmpty(owner._id),
  )
  const {
    isNew,
    visible,
    checkForm,
    modalType,
    remove,
    removing,
    submitting,
    formRef,
    onShow,
    onCancel,
    object: paymentTerm,
    update,
    setSubmitting,
  } = useModalData(PaymentTermsApi.create, PaymentTermsApi.update, PaymentTermsApi.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await PaymentTermsApi.create({
        ...newObject,
        owner,
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <PaymentTerms
      {...{
        isNew,
        visible,
        checkForm,
        modalType,
        remove,
        removing,
        submitting,
        submit,
        formRef,
        onShow,
        onCancel,
        paymentTerm,
        update,
        fetching,
        fetch,
        list,
        isUpdatable,
      }}
    />
  )
}

export default PaymentTermsCont
